import React from "react";
import { NavLink } from "react-router-dom";
import ReactPlayer from "react-player";

var bgimg1 =
  require("../../images/video-img.jpg")

class About3 extends React.Component {
  render() {
    return (
      <>
        <div
          className={`${this.props.bgcolor} section-full mobile-page-padding p-t80 p-b50`}
          style={{ backgroundColor: '#045384' }}
        >
          <div className="hilite-title text-left p-l50 text-uppercase">
            <strong style={{ color: 'rgb(158 158 158 / 21%)' }}>Objectifs</strong>
          </div>
          <div className="container">
            <div className="section-content">
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12">
                  <div className="video-section-full-v2">
                    <div
                      className="video-section-full bg-no-repeat bg-cover bg-center overlay-wraper m-b30"
                      style={{ backgroundImage: "url(" + bgimg1 + ")" }}
                    >
                      <div className="overlay-main bg-black opacity-04" />
                      <div className="video-section-inner">
                        <div className="video-section-content">
                          <NavLink
                            to={"#"}
                            className="play-now"
                            data-toggle="modal"
                            data-target="#myModal"
                          >
                            <i className="icon fa fa-play" />
                            <span className="ripple" />
                          </NavLink>

                          <div className="video-section-bottom">
                            <h3 className="sx-title text-white">
                              Vallée
                              <br />
                              Val d’Or
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12">
                  <div className="about-home-3 m-b30">
                    <h3 className="m-t0 m-b20 sx-tilte text-white">
                      Objectifs de l’Association la vallée :
                    </h3>
                    <p className="text-white">
                      Veiller à répondre aux besoins de ses adhérents et à agir
                      pour une société meilleure afin de développer le « vivre
                      ensemble » et œuvrer pour l’intérêt général
                    </p>
                    <ul className="list-angle-right anchor-line text-white">
                      <li className="text-white">
                        Organiser des activités pédagogiques, culturelles,
                        sportives et de loisirs au profit des adhérents et des
                        membres de leur famille
                      </li>
                      <li>
                        Réaliser des programmes sociaux comprenant notamment des
                        projets d’habitat au profit de ses adhérents ;
                      </li>
                      <li>
                        Organiser des actions de bienfaisance et d’aide en
                        faveur des personnes démunies ;
                      </li>
                      <li>
                        Créer des relations de coopération et de partenariat
                        avec d’autres associations et organisations similaires
                      </li>
                    </ul>
                    {/* <div className="text-left">
                      <NavLink to="/about" className="site-button btn-half">
                        <span>Read More</span>
                      </NavLink>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" id="myModal" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <ReactPlayer
                  controls={true}
                  url={require("../../videos/vallee-1er.mp4")}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default About3;
